/**
 * Service response utilities for Phase 4 / legacy compatibility.
 * Use these when you need a string from "error" (string | ServiceError) or when
 * converting LegacyServiceResponse to ServiceResponse.
 *
 * @see docs/fixes/TS2322_FIX_STRATEGY.md
 */

import type { ServiceError } from "@flowstate/types";

/** Error that might be string or ServiceError (legacy). */
export type ErrorLike = string | ServiceError | undefined | null;

/**
 * Normalize error to a string for display, toast, or new Error().
 * Use wherever you pass result.error / response.error to something that expects string.
 *
 * @example
 * if (!response.success) throw new Error(getErrorMessage(response.error));
 * toast.error(getErrorMessage(response.error));
 */
export function getErrorMessage(error: ErrorLike): string {
  if (error == null) {return "Unknown error";}
  if (typeof error === "string") {return error;}
  return error.message ?? "Unknown error";
}
